module.exports = __webpack_public_path__ + "img/media_2.6045f701.png";